<div class="content">
  <p>{{ 'PAYMENT.PROGRESS' | translate }}</p>
  <mat-spinner class="loader"></mat-spinner>
  <p>{{ 'PAYMENT.CANCEL' | translate }}</p>
</div>
